export default {
  INVALID_PROZIS_POINTS: 3182,
  SURVEY_NOT_FOUND: 3180
};
